<template>
  <v-card class="board__card pa-3" rounded="lg">
    <v-badge class="board__badge" dot />
    <v-row align="center" no-gutters>
      <v-col cols="8" class="subtitle-2 grey--text text--darken-3">
        Fulano de Tal
      </v-col>
      <v-col cols="4" class="caption grey--text text-right">
        12/12/2021
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'BoardCardPending',
}
</script>
